import { UIElement, UIElementOptions } from "./ui/uiElement";
import { UIManager } from "./ui/uiManager";

interface LoadingBarOptions extends UIElementOptions {
  speed?:number;
}

export class LoadingBar extends UIElement {
  protected lastUpdateTime: number;
  protected backColor:string;
  protected fillColor:string;
  protected loadingValue:number;
  protected direction:number;
  protected running:boolean;

  constructor(options: LoadingBarOptions) {
    super(options);
    this.lastUpdateTime = 0;
    this.backColor = '#00000040';
    this.fillColor = '#ffffffa0';
    this.loadingValue = 0;
    this.direction = 1;
    this.running = false;
  }

  public update() {
    super.update();

    var now = performance.now();
    var elapsed = now - this.lastUpdateTime;
    this.lastUpdateTime = now;

    if(!this.running)
      return;

    var inc = (elapsed * 0.00045);
    this.loadingValue += (inc * this.direction);

    if(this.loadingValue > 1) {
      this.loadingValue = 1;
      this.direction *= -1;
    }
    else if(this.loadingValue < 0.05) {
      this.loadingValue = 0.05;
      this.direction *= -1;
    }
  }

  public start() {
    this.running = true;
    this.loadingValue = 0;
    this.lastUpdateTime = performance.now();
  }

  public createPath(sx:number, sy:number, sw:number, sh:number):Path2D {
    let radius = 6;
    let path = new Path2D();
    path.moveTo(sx + radius, sy);
    path.lineTo(sx + sw - radius, sy);
    path.quadraticCurveTo(sx + sw, sy, sx + sw, sy + radius);
    path.lineTo(sx + sw, sy + sh - radius);
    path.quadraticCurveTo(sx + sw, sy + sh, sx + sw - radius, sy + sh);
    path.lineTo(sx + radius, sy + sh);
    path.quadraticCurveTo(sx, sy + sh, sx, sy + sh - radius);
    path.lineTo(sx, sy + radius);
    path.quadraticCurveTo(sx, sy, sx + radius, sy);
    path.closePath();
    return path;
  }

  public draw() {
    let backPath = this.createPath(this.getScreenX(), this.getScreenY(), this.width, this.height);
    UIManager.ctx.fillStyle = this.backColor;
    UIManager.ctx.fill(backPath);

    let fw = this.width * this.loadingValue;
    if(fw > 0 && this.running) {
      let fx = this.getScreenX() + (this.width/2) - (fw/2);
      let fillPath = this.createPath(fx, this.getScreenY(), fw, this.height);
      UIManager.ctx.fillStyle = this.fillColor;
      UIManager.ctx.fill(fillPath);
    }
  }
}